import { useEffect, useMemo, useState } from "react";
import images from "../../../assets/images/constantImages";
import { useDispatch, useSelector } from "react-redux";
import { formatRupees } from "../../Common/ApiCommon/ApiService";
import icons from "../../../assets/images/constantIcons";
import EditCombos from "./EditCombos";
import DeleteCombo from "./DeleteCombo";
import { getComboOffers } from "./ComboSlice";

const useAddCombo = () => {
  const dispatch = useDispatch();
  const [selectedCombo, setSelectedCombo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [editPopupIndex, setEditPopupIndex] = useState(null);
  const [deletePopupIndex, setDeletePopupIndex] = useState(null);

  // Get data from Redux
  const { comboOffers, loading } = useSelector((state) => state.comboOffers);

  useEffect(() => {
    dispatch(getComboOffers());
  }, [dispatch]);

  const handleDeleteItem = (id) => {
    setDeletePopupIndex(id);
  };

  const handleEditItems = (id) => {
    const combo = comboOffers?.find((item) => item.id === id);
    setSelectedCombo(combo);
    setEditPopupIndex(id);
  };
  const columns = useMemo(
    () => [
      {
        Header: "Combo Name",
        accessor: "name",
        headerAlign: "text-left",
        cellAlign: "text-left",
        Cell: ({ row }) => {
          const imageUrl = row.original.image
            ? `https://headquater.pixoatic.com${row.original.image}`
            : images.defaultprofilepicture;

          return (
            <div className="flex items-center gap-2">
              <img
                src={imageUrl}
                alt={row.original.name}
                className="w-8 h-8 object-cover rounded-full"
              />
              <span>{row.original.name}</span>
            </div>
          );
        },
      },
      {
        Header: "Items",
        accessor: "combo_items",

      },
      {
        Header: "Price",
        accessor: "price",
        Cell: ({ value }) => (
          <div className="text-nowrap">{formatRupees(value)}</div>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        headerAlign: "text-center",
        cellAlign: "text-center",
        disableSortBy: true,
        Cell: ({ value }) => (
          <p
            className={`text-xs md:text-sm font-medium flex justify-center items-center rounded-md w-[72px] md:w-auto px-4 py-[6px] ${value === "Active"
              ? "text-green bg-green bg-opacity-[10%]"
              : "text-red bg-red bg-opacity-[10%]"
              }`}
          >
            {value}
          </p>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        headerAlign: "text-left",
        cellAlign: "text-center",
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="flex justify-start lg:justify-center gap-5">
            <button
              onClick={() => handleEditItems(row.original.id)}
              className="p-2 w-[40px] h-[40px] rounded-full bg-green50 text-green"
            >
              <icons.FaRegEdit className="text-xl" />
            </button>
            {editPopupIndex === row.original.id && (
              <EditCombos
                isOpen={true}
                onClose={() => {
                  setEditPopupIndex(null);
                  setSelectedCombo(null);
                }}
                comboData={selectedCombo}
              />
            )}
            <button
              onClick={() => handleDeleteItem(row.original.id)}
              className="p-2 w-[40px] h-[40px] rounded-full bg-red bg-opacity-15 text-red"
            >
              <icons.AiOutlineDelete className="text-xl" />
            </button>
            {deletePopupIndex === row.original.id && (
              <DeleteCombo
                isOpen={() => deletePopupIndex(true)}
                onClose={() => setDeletePopupIndex(null)}
                comboID={row.original.id}
              />
            )}
          </div>
        ),
      },
    ],
    [editPopupIndex, deletePopupIndex]
  );

  const data = (comboOffers || []).map((item) => ({
    id: item.id,
    name: item.combo_offer_name,
    combo_items: item.combo_items?.join(", "),
    price: parseFloat(item.price),
    status: item.status==="active"?"Active":"Inactive",
    image: item.image_url,
  }));

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data?.slice(indexOfFirstRow, indexOfLastRow);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  return {
    columns,
    currentRows,
    totalRows: data?.length,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    loading,
  };
};

export default useAddCombo;
